import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpClient from "../helpers/httpClient";

const initialState = {
  deliveryFeeRanges: {
    data: [],
    loading: false,
    error: null,
  },
  selectedDeliveryFeeRange: {
    data: {},
    loading: false,
  },
};

export const getDeliveryFeeRanges = createAsyncThunk(
  "deliveryFeeRanges/getDeliveryFeeRanges",
  async () => {
    try {
      const response = await httpClient.get("/web/delivery-fee-ranges");
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const addDeliveryFeeRange = createAsyncThunk(
  "deliveryFeeRanges/addDeliveryFeeRange",
  async (deliveryFeeRange) => {
    try {
      const response = await httpClient.post(
        "/web/delivery-fee-ranges",
        deliveryFeeRange
      );
      return response.data;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const updateDeliveryFeeRange = createAsyncThunk(
  "deliveryFeeRanges/updateDeliveryFeeRange",
  async (deliveryFeeRange) => {
    try {
      const response = await httpClient.put(
        `/web/delivery-fee-ranges/${deliveryFeeRange?._id}`,
        deliveryFeeRange
      );
      return response.data;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const deleteDeliveryFeeRange = createAsyncThunk(
  "deliveryFeeRanges/deleteDeliveryFeeRange",
  async (id) => {
    try {
      const response = await httpClient.delete(
        `/web/delivery-fee-ranges/${id}`
      );
      return response.data;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getDeliveryFeeRangeById = createAsyncThunk(
  "deliveryFeeRanges/getDeliveryFeeRangeById",
  async (id) => {
    try {
      const response = await httpClient.get(`/web/delivery-fee-ranges/${id}`);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

const deliveryFeeRangesSlice = createSlice({
  name: "deliveryFeeRanges",
  initialState,
  reducers: {
    setSelectedDeliveryFeeRange: (state, action) => {
      state.selectedDeliveryFeeRange.data = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getDeliveryFeeRanges.pending, (state) => {
        state.deliveryFeeRanges.loading = true;
      })
      .addCase(getDeliveryFeeRanges.fulfilled, (state, { payload }) => {
        state.deliveryFeeRanges.data = payload;
        state.deliveryFeeRanges.loading = false;
      })
      .addCase(getDeliveryFeeRanges.rejected, (state, { payload }) => {
        state.deliveryFeeRanges.error = payload;
        state.deliveryFeeRanges.loading = false;
      })
      .addCase(addDeliveryFeeRange.pending, (state) => {
        state.deliveryFeeRanges.loading = true;
      })
      .addCase(addDeliveryFeeRange.fulfilled, (state, { payload }) => {
        state.deliveryFeeRanges.data.push(payload.res);
        state.deliveryFeeRanges.loading = false;
      })
      .addCase(addDeliveryFeeRange.rejected, (state, { payload }) => {
        state.deliveryFeeRanges.error = payload;
        state.deliveryFeeRanges.loading = false;
      })
      .addCase(updateDeliveryFeeRange.pending, (state) => {
        state.deliveryFeeRanges.loading = true;
      })
      .addCase(updateDeliveryFeeRange.fulfilled, (state, { payload }) => {
        state.deliveryFeeRanges.data = state.deliveryFeeRanges.data.map(
          (deliveryFeeRange) =>
            deliveryFeeRange._id === payload.res._id
              ? payload.res
              : deliveryFeeRange
        );
        state.deliveryFeeRanges.loading = false;
      })
      .addCase(updateDeliveryFeeRange.rejected, (state, { payload }) => {
        state.deliveryFeeRanges.error = payload;
        state.deliveryFeeRanges.loading = false;
      })
      .addCase(deleteDeliveryFeeRange.pending, (state) => {
        state.deliveryFeeRanges.loading = true;
      })
      .addCase(deleteDeliveryFeeRange.fulfilled, (state, { payload }) => {
        state.deliveryFeeRanges.data = state.deliveryFeeRanges.data.filter(
          (deliveryFeeRange) => deliveryFeeRange._id !== payload.res._id
        );
        state.deliveryFeeRanges.loading = false;
      })
      .addCase(deleteDeliveryFeeRange.rejected, (state, { payload }) => {
        state.deliveryFeeRanges.error = payload;
        state.deliveryFeeRanges.loading = false;
      })
      .addCase(getDeliveryFeeRangeById.pending, (state) => {
        state.selectedDeliveryFeeRange.loading = true;
      })
      .addCase(getDeliveryFeeRangeById.fulfilled, (state, { payload }) => {
        state.selectedDeliveryFeeRange.data = payload;
        state.selectedDeliveryFeeRange.loading = false;
      })
      .addCase(getDeliveryFeeRangeById.rejected, (state) => {
        state.selectedDeliveryFeeRange.loading = false;
      }),
});

export const { setSelectedDeliveryFeeRange } = deliveryFeeRangesSlice.actions;

export default deliveryFeeRangesSlice.reducer;
